const state = {
  show: false,
};

const actions = {
  setShow({ state }, { show }) {
    state.show = show;
  },
};

const getters = {
  getShow(s) {
    return s.show;
  },
};

export default {
  state,
  actions,
  getters,
  namespaced: true,
};
